import BackButton from "../../components/onboarding/back-button";

const ServiceContent = () => {
    return (
        <div style={{ fontSize: 24, padding: 14, lineHeight: 1.3 }}>
            <BackButton />
            <h1 style={{ fontSize: 34, fontWeight: 800, marginTop: 50 }}>서비스 이용 약관</h1>
            <h1 style={{ fontSize: 20, fontWeight: 600, color: "gray" }}>2023년 11월 23일 제정</h1>
            <br />
            <br />
            <h1 style={{ fontSize: 28, fontWeight: 700 }}> 제1조 머리말</h1> <br />
            <br />
            '에호'(이하 ‘본 서비스’라 한다)란 feople(이하 ‘당사’라 한다)이 운영하며, 자녀 및 가족의 사진을 모은 전자
            앨범을 제작하여 가족 간에 공유하기 위한 커뮤니케이션 서비스입니다. 본 서비스를 이용하기 위해서는 본 ‘에호’
            이용 약관(이하 ‘본 약관’이라 한다)에 동의한 후에 이용해 주십시오. 본 서비스의 유저(이하 ‘이용자’라 한다)는
            본 약관의 모든 기재 내용에 대하여 동의하는 것으로 간주합니다. 당사는 본 서비스에서의 게재 또는 개별적인 전자
            메일에 의한 송신과 기타 적절한 방법을 통해 변경 내용 및 변경 시기를 공지함으로써 본 약관을 변경할 수
            있습니다. 변경 후의 본 약관은 당사가 별도로 정하는 경우를 제외하고, 본 서비스 상에 표시한 후에 처음으로
            이용자가 본 서비스를 이용한 시점부터 효력이 발생합니다. 본 서비스에는 본 약관 및 기타 약관 등에서 이용
            조건이 규정되어 있습니다. 기타 약관 등은 명칭의 여부에 관계없이 본 약관의 일부를 구성합니다. 본 약관의
            규정과 기타 약관 등의 규정이 모순되는 경우에는 당사가 별도로 정하는 경우를 제외하고 본 약관의 규정이 우선
            적용됩니다. <br />
            <br />
            <h1 style={{ fontSize: 28, fontWeight: 700 }}> 제2조 계정 등록 관리</h1> <br />
            <br />
            이용자(이용자 중 가족을 생성하는 등의 관리 권한을 가진 자. 이하 같음) 및 열람 이용자(이용자 중 관리
            이용자에게 초대를 받아 해당 관리 이용자의 가족에서의 활동을 하는 자. 이하 같음)가 본 서비스를 이용하는
            경우에는 본 약관의 내용에 동의한 다음 당사 소정의 방법을 통해 계정을 등록합니다. 본 서비스는 당사가 별도로
            인정하는 경우를 제외하고 법인이 계정을 등록할 수는 없습니다. 미성년자가 본 서비스를 이용하는 경우에는
            친권자의 동의를 얻은 후에 이용할 수 있습니다. 제3조 제1항의 계정 정보란 별도로 본 서비스의 취지에 근거하여
            등록 시에 입력해야 하는 정보(자녀 정보 등)가 있으나, 당사에서는 이러한 정보의 정확성은 확인하지 않으며, 만일
            부정확하더라도 해당 이용자의 이용을 제한하지는 않습니다. 또한 이러한 정보에 대해서는 입력한 이용자가 모든
            책임을 집니다. 이용자가 다음 각호 중 어느 하나에 해당하는 경우에는 이용을 거절할 수 있습니다. 본 조 제1항의
            방법에 따르지 않고 계정을 등록한 경우 과거에 본 약관을 위반한 것을 이유로 어떠한 처분을 받은 자인 경우
            당사가 제공하는 다른 서비스에서 어떠한 처분을 받은 적이 있는 경우 기타 당사가 부적절하다고 판단한 경우
            <br />
            <br /> <h1 style={{ fontSize: 28, fontWeight: 700 }}> 제3조 계정 관리 관리</h1> <br />
            <br />
            이용자는 자신 및 자신이 초대한 열람 이용자의 계정 등록에 필요한 소정의 정보(별명, 가족 구성원으로써의 역할을
            포함)의 부정 이용 방지를 위해 노력하며, 그 관리에 대해서 모든 책임을 집니다. 이용자는 어떠한 경우에도 계정을
            제삼자에게 양도 또는 대여할 수 없습니다. <br />
            <br />
            <h1 style={{ fontSize: 28, fontWeight: 700 }}> 제4조 이용자의 책임</h1> <br />
            <br />
            이용자는 자신의 책임과 판단하에 본 서비스를 이용하며, 관리 이용자는 초대한 열람 이용자의 행위에 책임을
            지니고 적절히 관리합니다. 이용자는 본 서비스를 이용하기 위해서 필요한 모든 기기, 소프트웨어, 통신 수단을
            자신의 책임과 비용으로 적절히 정비합니다. 이용자는 자신의 이용 환경에 따라 컴퓨터 바이러스 감염 방지, 무단
            액세스 및 정보 누출 방지 등의 보안 대책을 강구합니다. 당사는 이용자의 이용 환경에 대해서 전혀 관여하지
            않으며, 또한 어떠한 책임도 지지 않습니다. <br />
            <br />
            <h1 style={{ fontSize: 28, fontWeight: 700 }}> 제5조 본 서비스의 내용</h1> <br />
            <br />본 서비스에서 모든 이용자는 관리 이용자가 만든 가족이라는 그룹 내에서 자신이 촬영한 사진을 공유할 수
            있고, 서로에게 사진을 요청할 수 있으며, 본인에게 도착한 사진만을 열람할 수 있습니다. 관리 이용자는 본
            서비스를 이용해서 가족단위를 지칭하는 코드를 생성할 수 있고, 해당 코드를 다른 가족에게 공유하여 열람
            이용자를 참여시킬 수 있습니다. 단, 관리 이용자의 가족에는 5명이라는 인원 제한이 존재합니다. 전항에 따라 초대
            받는 사람은 원칙적으로 초대하는 관리 이용자의 가족 또는 이와 동등한 면식이 있는 개인으로 한정합니다. 단,
            당사가 별도로 인정하는 경우는 제외합니다. <br />
            <br />
            <h1 style={{ fontSize: 28, fontWeight: 700 }}> 제6조 애플리케이션의 이용 허락 등</h1> <br />
            <br />
            당사는 본 서비스의 애플리케이션(이하 ‘본 앱’이라 한다)을 제공하는 경우 이용자에 대해 본 약관이 정하는 조건에
            따라 본 앱의 양도는 불가하며, 비독점적인 이용권을 허락하되, 본 약관은 장래에 개발될 본 앱의 업그레이드 등에
            대한 이용권을 허락하는 것은 아닙니다. 당사는 이용자에게 통지하지 않고 본 앱의 기능 또는 사양을 변경할 수
            있습니다. 당사는 본 앱에 대한 모든 동작 보증, 이용 목적에 대한 적합성 보증, 이용 결과에 관한 적확성이나
            신뢰성을 보증하지 않으며, 동시에 어떠한 내용의 하자 담보 책임도 지지 않습니다. 이용자는 본 앱 및 본 앱의
            정보를 서면을 통한 당사의 사전 동의 없이 무단으로 복제, 전재, 재배포 등의 행위를 해서는 안 됩니다. 이용자는
            본 앱을 수정, 변경, 개변, 리버스 엔지니어링, 역컴파일, 역어셈블 등의 행위를 해서는 안 됩니다. 본 앱은 일정
            기간마다 네트워크에 연결하여 통신하는 경우가 있습니다. 이 경우에는 별도의 통신료가 듭니다. 본 앱의 표시 및
            본 앱의 동작에 필요한 프로그램 데이터 및 관련 문서 파일 등은 예고 없이 자동으로 변경ㆍ업데이트되는 경우가
            있습니다. 본 앱 실행 중에 권외로의 이동 등으로 네트워크에 연결할 수 없는 경우나 건물 내, 빌딩 뒤 등에서
            통신을 할 수 없는 경우에는 일시적으로 본 앱을 이용할 수 없게 될 경우가 있습니다. 본 앱을 다운로드할 때는
            별도의 통신료가 발생합니다. <br />
            <br />
            <h1 style={{ fontSize: 28, fontWeight: 700 }}> 제7조 서비스의 변경 등</h1>
            <br />
            <br /> 당사는 당사의 사정으로 인해 본 서비스 및 본 앱을 언제든지 임의의 이유로 그 기능의 일부 또는 전부의
            이용을 제한, 추가, 중지 또는 제공 변경, 중단, 종료할 수 있습니다. 본 서비스 및 본 앱의 변경, 이용 제한, 중지
            또는 제공의 중단, 종료 등으로 인해 이용자에게 발생한 손해에 대해 당사는 고의 또는 중과실에 의한 경우를
            제외하고 어떠한 책임도 지지 않습니다. <br />
            <br />
            <h1 style={{ fontSize: 28, fontWeight: 700 }}> 제8조 이용 요금 등</h1>
            <br />
            <br /> 본 서비스는 원칙적으로 무료입니다. 당사가 추후에 본 서비스의 이용 대가를 요구하는 경우가 생긴다면
            사용자에게 사전에 통지하고 동의를 얻는 것으로 합니다. <br />
            <br />
            <h1 style={{ fontSize: 28, fontWeight: 700 }}> 제9조 사진 등에 관한 권리와 책임</h1>
            <br />
            <br /> 이용자는 당사에 대해 해당 사진 등이 당사 또는 제삼자의 권리를 침해하지 않는 것을 보증합니다. 이용자가
            당사 또는 제삼자의 명예를 훼손한 경우, 프라이버시권을 침해한 경우, 허락 없이 당사 또는 제삼자의 개인 정보를
            공개한 경우, 저작권법을 위반하는 행위를 한 경우, 기타 당사 또는 제삼자의 권리를 침해한 경우에는 해당
            이용자는 자신의 책임과 비용으로 해결해야 합니다. 이용자는 사진 등에 대해 이용자 자신의 자기 책임하에
            백업해야 합니다. <br />
            <br />
            <h1 style={{ fontSize: 28, fontWeight: 700 }}> 제10조 본 서비스에 관한 권리</h1>
            <br />
            <br /> 전조에서 정하는 경우를 제외하고 본 서비스를 구성하는 소재(사진 촬영 레이아웃), 기능 및 본 서비스(이하
            모두 ‘소재 등’이라 한다)에 관한 모든 권리(소유권, 지적 재산권, 초상권, 퍼블리시티권)는 당사 또는 제삼자에게
            귀속됩니다. 이용자는 소재 등을 본 서비스의 이용에 필요한 범위에서 이용할 수 있습니다. 단, 당사는 소재 등의
            어떠한 권리도 이용자에게 이용 허락 또는 양도하는 것은 아닙니다. <br />
            <br />
            <h1 style={{ fontSize: 28, fontWeight: 700 }}> 제11조 개인 정보의 취급</h1>
            <br />
            <br /> 당사는 개인 정보를 ‘개인정보 처리방침’ 에 따라 적절하게 취급하는 것으로 합니다.당사가 취득하는 개인
            정보는 본 서비스의 제공ㆍ운영ㆍ개발ㆍ개선 및 이용자 지원에 필요한 범위로 하며, 이용자의 동의 없이 필요
            이상의 개인 정보를 취득하지 않습니다.당사는 14세 이하 이용자의 개인 정보에 대해 이용자의 친권자의 요청에
            기반하여 친권자 본인임을 확인한 다음 내용의 공개 및 삭제를 실시하는 경우가 있습니다. <br />
            <br />
            <h1 style={{ fontSize: 28, fontWeight: 700 }}> 제12조 계정 삭제 관리</h1>
            <br />
            <br /> 이용자 및 열람 이용자가 계정의 삭제를 희망하는 경우에는 해당 이용자는 당사 소정의 방법을 통해 계정을
            삭제할 수 있습니다. 당사는 이용자가 다음 각호에 게시한 내용 중 어느 하나에 해당하는 경우에는 당사의 판단에
            따라 계정을 강제적으로 삭제하고 본 서비스의 이용을 거절할 수 있습니다. <br />
            <br />- 제2조 제1항의 방법에 따르지 않고 계정을 등록한 사실이 밝혀진 경우 <br />- 본 약관을 위반한 경우{" "}
            <br />- 당사가 제공하는 다른 서비스에서 어떠한 처분을 받은 적이 있는 경우 <br />- 기타 당사가 부적절하다고
            판단한 경우 <br />
            <br />
            <h1 style={{ fontSize: 28, fontWeight: 700 }}> 제13조 금지 사항</h1>
            <br />
            <br /> 이용자는 본 서비스에서 다음과 같은 행위를 해서는 안 됩니다. <br />
            <br />
            -당사 또는 제삼자의 저작권, 상표권 등의 지적 재산권을 침해하는 행위 또는 침해할 우려가 있는 행위. <br />
            -당사 또는 제삼자의 재산, 프라이버시 또는 초상권을 침해하는 행위 또는 침해할 우려가 있는 행위. <br />
            -당사 또는 제삼자를 부당하게 차별 또는 비방ㆍ중상하고, 당사 또는 제삼자에 대한 부당한 차별을 조장하거나 그
            명예나 신용을 훼손하는 행위. <br />
            -본인 이외의 인물을 사칭하거나 대표권 및 대리권이 없음에도 불구하고 있는 것처럼 가장하거나 다른 인물이나
            조직과 연계 및 협력 관계에 있다고 속이는 행위. <br />
            -사기, 규제 약물 또는 지정 약물 등의 남용, 아동 성매매, 예저금 계좌 및 휴대 전화의 불법 매매 등의 범죄로
            이어지거나 이어질 우려가 있는 행위. <br />
            -외설, 아동 포르노 또는 아동 학대에 상당하는 사진 등을 게시하는 행위 또는 이러한 정보를 수록한 매체를
            판매하는 행위 또는 그 송신, 표시, 판매를 연상시키는 광고를 게시하는 행위. <br />
            -성행위, 외설적인 행위 등을 목적으로 이용하는 행위. <br />
            -일면식도 없는 타인과의 만남 등을 목적으로 이용하는 행위. <br />
            -불법 도박ㆍ내기를 시키거나 불법 도박ㆍ내기에 참여를 권유하는 행위. <br />
            -불법 행위(권총 등의 양도, 폭발물의 제조, 아동 포르노의 제공, 공문서 위조, 살인, 협박 등)를 청부하고
            중개하거나 유인하는 행위. <br />
            -타인을 자살로 유인하거나 권유하는 행위 또는 타인에게 위해가 미칠 우려가 높은 자살 수단 등을 소개하는 등의
            행위.
            <br />
            -살인ㆍ상해 현장, 시체 등 기타 잔혹한 행위를 촬영한 사진 등 또는 사회 통념상 타인에게 혐오감을 주거나 다른
            이용자가 불쾌함을 느낄 가능성이 높은 사진 등을 게시하는 행위. <br />
            -다단계 판매(피라미드 판매)를 개설하거나 이를 권유하는 행위. <br />
            -성인 사이트, 원클릭 사기 사이트, 바이러스 등의 유해한 컴퓨터 프로그램 등을 유포하는 것을 목적으로 하는
            사이트 등으로 유도하는 행위(단순히 링크를 거는 행위도 포함). <br />
            -영리를 목적으로 이용하는 행위.
            <br />
            -본 서비스의 본래 목적을 넘어서 전자 앨범(앨범 URL을 포함)을 불특정 다수에게 공개하거나 불특정 다수가 열람할
            가능성이 있는 장소에 공개하는 행위. <br />
            -당사의 설비에 축적된 정보를 부정하게 수정하거나 삭제하는 행위.
            <br />
            -바이러스 등의 유해한 컴퓨터 프로그램 등을 송신 또는 게재하는 행위. <br />
            -당사 또는 제삼자의 서버에 부하를 주는 행위 또는 본 서비스의 운영 및 네트워크 시스템에 지장을 주는 행위 또는
            그럴 우려가 있는 행위. <br />
            -그 행위가 전 각호 중 어느 하나에 해당하는 것을 알면서도 그 행위를 조장할 목적으로 링크를 거는 행위. <br />
            -법령, 공서 양속에 위배되거나 타인의 권리를 침해하는 행위. <br />
            -기타 다른 이용자에게 피해를 주는 행위. <br />
            <br />
            <h1 style={{ fontSize: 28, fontWeight: 700 }}> 제14조 광고</h1>
            <br />
            <br /> 등 당사는 본 서비스 상에 광고를 표시하지 않습니다. <br />
            <br />
            <h1 style={{ fontSize: 28, fontWeight: 700 }}> 제15조 권리 양도의 금지 </h1>
            <br />
            <br />
            이용자는 본 약관에서 정한 경우를 제외하고, 본 약관에 따른 어떠한 권리 또는 의무도 제삼자에게 이전, 양도와
            같은 처분을 할 수 없습니다. <br />
            <br />
            <h1 style={{ fontSize: 28, fontWeight: 700 }}> 제16조 면책</h1>
            <br />
            <br /> 당사는 본 서비스에 대한 이용자의 통신 및 활동에 책임을 지지 않습니다. 만일 이용자 간 또는 제삼자와의
            트러블ㆍ분쟁이 발생한 경우에도 해당 당사자 간에 해결하는 것으로 합니다. 접속 과다와 기타 예기치 않은
            요인으로 표시 속도의 저하 및 장애 등으로 발생한 손해에 대해 당사는 어떠한 책임도 지지 않습니다. 당사는 사진
            등을 감시하거나 저장할 의무를 지지 않습니다. 당사는 본 서비스에서의 모든 동작 보증, 이용 목적에 대한 적합성
            보증, 이용 결과에 관한 적확성이나 신뢰성을 보증하지 않으며, 동시에 어떠한 내용의 하자 담보 책임도 지지
            않습니다. 당사는 다음과 같은 경우에는 해당 사진 등의 내용을 열람하거나 저장하거나 제삼자에게 공개할 수
            있습니다. 당사는 이로 인해 발생한 어떠한 손해에 대해서도 어떠한 책임도 지지 않습니다. 본 서비스의 기술적
            결함의 원인을 규명하고 해소하기 위해 필요한 경우. 법원이나 경찰 등의 공적 기관으로부터 법령에 따른 정식
            조회를 받은 경우. 본 약관을 위반하는 행위 또는 그럴 우려가 있는 행위가 발생하여 사진 등의 내용을 확인할
            필요가 생긴 경우. 타인의 생명, 신체 및 재산 등에 긴박한 위험이 있어 긴급 대처의 필요성이 발생한 경우. 그
            밖에 본 서비스를 적절하게 운영하기 위해 필요한 경우. 당사는 본 약관을 위반하는 행위 또는 그럴 우려가 있는
            행위가 발생했다고 믿을 만한 상당한 이유가 있다고 판단한 경우에는 해당 행위를 한 이용자에 대해 사전 통지를
            하지 않고 사진 등의 삭제 및 이용 제한 등 당사가 필요하다고 생각하는 조치를 강구할 수 있으며, 이로 인해
            발생한 어떠한 손해에 대해서도 고의 또는 중과실에 의한 경우를 제외하고 어떠한 책임도 지지 않습니다. 이용자는
            당사가 본 항의 규정에 따라 실시한 조치에 대해 이의를 제기할 수 없습니다. 본 약관이 소비자 계약법(2000년 법률
            제61호) 제2조 제3항의 소비자 계약에 해당하는 경우에는 본 약관 중 당사의 손해 배상 책임을 완전히 면책하는
            규정은 적용되지 않습니다. 이 경우에 이용자에게 발생한 손해가 당사의 채무 불이행 또는 불법 행위에 근거할 때는
            당사는 해당 이용자가 당사에 본 서비스의 대가로 지불한 1개월분의 요금을 상한으로 손해 배상 책임을 집니다. 단,
            당사에 고의 또는 중과실이 있는 경우는 제외합니다. 본 약관의 규정에 관계없이 어떠한 경우에도 당사는 본
            서비스에 관해 다음과 같은 손해에 대해서는 어떠한 책임도 지지 않습니다. 당사의 귀책사유로 돌릴 수 없는 사유로
            인해 발생한 손해. 당사의 예견 여부에 관계없이 특별한 사정으로 인해 발생한 손해. 서버 점검 등 본 서비스 제공
            시에 필요 불가결한 행위로 인해 발생한 손해. <br />
            <br />
            <h1 style={{ fontSize: 28, fontWeight: 700 }}> 제17조 기타</h1>
            <br />
            <br /> 본 약관의 일부가 법령에 따라 무효로 판단되더라도 그 밖의 규정은 유효합니다. 본 약관의 일부가 어느
            사용자와의 관계에서 무효가 되거나 취소된 경우에도 본 약관은 다른 이용자와의 관계에서는 유효합니다.
        </div>
    );
};
export default ServiceContent;
